export default __webpack_public_path__ + "static/media/07.22eec008.webp";